import React, { useState, useEffect } from "react";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  // Autocomplete,
  Typography,
  TextField,
  CircularProgress,
  InputAdornment,
  // Box,
  Backdrop,
} from "@material-ui/core";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { calculateTax, getTaxCode, getWHTCodeByTaxCode } from "../../actions";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style";
import jwt from "jsonwebtoken";
import Select from "react-select";
import "./style.css";
import Spinner from "../../../Spinner/Spinnerv2";
import getParameterByName from "../../../../Functions/functions";
const token = localStorage.getItem("user_token");
const user = jwt.decode(token);

const TaxDetail = ({
  formState,
  setFormState,
  disabled,
  invoice_Amount,
  edit,
}) => {
  const roleName = getParameterByName("roleName");
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [taxCodeListLoading, setTaxCodeListLoading] = useState(true);
  const [taxCalculateLoading, setTaxCalculateLoading] = useState(false);
  // const [selectedTaxCode, setSelectedTaxCode] = useState(null);

  const useStyles = makeStyles(dashboardStyle);
  const classes = useStyles();

  // const filterOptions = createFilterOptions({
  //   stringify: (taxCodeList) => taxCodeList.TaxCode + taxCodeList.C,
  // });
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  useEffect(() => {
    getTaxCode(setTaxCodeList, setTaxCodeListLoading);
  }, []);

  const calculateTaxHandler = (checked) => {
    if (checked) {
      calculateTax(
        formState?.salesTaxCode,
        "PKR",
        invoice_Amount,
        setFormState,
        setTaxCalculateLoading
      );
    }

    setFormState((formState) => ({
      ...formState,
      calculateTax: checked,
    }));
  };
  const [firstTime, setFirstTime] = useState(true);
  useEffect(() => {
    if (
      formState?.salesTaxCode === "" &&
      taxCodeList?.length > 0 &&
      !taxCodeListLoading &&
      firstTime
    ) {
      if (user?.Location === "1") {
        const defaultTaxCode = taxCodeList.find(
          (item) => item?.TaxCode === "31"
        );
        setFormState((formState) => ({
          ...formState,
          salesTaxCode: defaultTaxCode?.TaxCode
            ? defaultTaxCode?.TaxCode
            : taxCodeList[0]?.TaxCode,
        }));
      } else {
        const defaultTaxCode = taxCodeList?.find(
          (item) => item?.TaxCode === "51"
        );
        setFormState((formState) => ({
          ...formState,
          salesTaxCode: defaultTaxCode.TaxCode
            ? defaultTaxCode.TaxCode
            : taxCodeList[0]?.TaxCode,
        }));
      }
    }
  }, [formState, taxCodeList, taxCodeListLoading]);

  // useEffect(() => {
  // if(saletaxcode === "true"){

  //   setFormState((formState) => ({
  //     ...formState,
  //     salesTaxCode: taxCodeList[2]?.TaxCode ,
  //   }));
  // }

  // }, [formState?.salesTaxCode]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: "lightgray", // Change the background color of the control
      ":focus": {
        borderColor: "gray", // Change the background color on hover
        boxShadow: "black !important",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the selected option
      color: "black",
      ":hover": {
        backgroundColor: "lightgray", // Change the background color on hover
      },
    }),
    menu: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the menu
      color: "white", // Change the font color of the menu
    }),
  };
  return (
    <>
      <Grid container spacing={1} style={{ margin: "10px 0px" }}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={roleName !== "IP" && taxCodeListLoading}
          // invisible={taxCodeListLoading}
        >
          <Spinner />
        </Backdrop>
        <Grid item xs={12} sm={12} md={6} lg={3} style={{ paddingLeft: "4px" }}>
          <Typography variant="h6" style={{ color: "black" }}>
            CNIC: {`  `}
            {formState.cnic}
          </Typography>{" "}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} style={{ paddingLeft: "0px" }}>
          <Typography variant="h6" style={{ color: "black" }}>
            NTN:{`  `} {formState.ntn}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={1} style={{ margin: "20px 0px" }}>
        {/* {roleName !== "AP Supervisor" && ( */}
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <FormControlLabel
            label="Calculate Tax"
            color="secondary"
            control={
              <Checkbox
                color="secondary"
                fontSize="small"
                checked={formState?.calculateTax || edit == "false"}
                onChange={(event) => {
                  calculateTaxHandler(event.target.checked);
                }}
                style={{ paddingLeft: "0px" }}
                disabled={
                  edit == "false"
                    ? true
                    : roleName === "IP"
                    ? false
                    : false || disabled
                }
                disableRipple={true}
              />
            }
          />
        </Grid>
        {/* )} */}
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Typography style={{ color: "black" }}>
            <span className={classes.asterisk}>*</span> Tax Code:
          </Typography>
          <Select
            className="basic-single"
            classNamePrefix="select"
            styles={customStyles}
            defaultValue={[taxCodeList?.[0]?.TaxCode]}
            value={{
              TaxCode: formState?.salesTaxCode?.split("-")[0] || "",
              Description:
                taxCodeList?.find(
                  (x) =>
                    x.TaxCode ===
                    formState?.salesTaxCode
                      ?.split("-")[0]
                      .replace(/^\s+|\s+$/gm, "")
                )?.Description || "",
            }}
            required={
              formState.salesTaxAmount === "" && roleName === "Tax Team"
            }
            // defaultValue={taxCodeList}
            // isDisabled={isDisabled}
            // isLoading={isLoading}
            // isClearable={isClearable}
            // isRtl={isRtl}
            isDisabled={edit == "false" ? true : false || disabled}
            isSearchable={true}
            isClearable={true}
            name="color"
            onChange={(event, actionMeta) => {
              if (actionMeta.action === "clear") {
                // Handle clear action
                setFirstTime(false);
                setFormState((formState) => ({
                  ...formState,
                  salesTaxCode: "", // Set to an appropriate empty value
                  salesTaxAmount: "0", // Adjust as needed
                }));
                // Additional logic for clear action if needed
              } else if (event?.TaxCode) {
                setFormState((formState) => ({
                  ...formState,
                  salesTaxCode: event?.TaxCode || "",
                  salesTaxAmount: event?.Description.includes("Exempt")
                    ? "0.01"
                    : event?.TaxCode === "51" || event?.TaxCode === "31"
                    ? "0"
                    : "0",
                }));

                formState?.calculateTax &&
                  calculateTax(
                    event?.TaxCode,
                    "PKR",
                    invoice_Amount,
                    setFormState,
                    setTaxCalculateLoading
                  );
                formState?.taxCard_List[0]?.taxType &&
                  getWHTCodeByTaxCode(setFormState, formState, event?.TaxCode);
              }
            }}
            options={taxCodeList}
            getOptionLabel={(option) =>
              (option &&
                `${option?.TaxCode} ${option?.TaxCode ? "-" : ""} ${
                  option?.Description
                }`) ||
              ""
            }
          />
          {/* <Autocomplete
            id="selectedTaxCode"
            options={taxCodeList}
            size="small"
            name=""
            value={{
              TaxCode: formState?.salesTaxCode?.split("-")[0] || "",
              Description:
                taxCodeList?.find(
                  (x) =>
                    x.TaxCode ===
                    formState?.salesTaxCode
                      ?.split("-")[0]
                      .replace(/^\s+|\s+$/gm, "")
                )?.Description || "",
            }}
            // value={selectedTaxCode}
            getOptionLabel={(option) =>
              (option &&
                `${option?.TaxCode} ${option?.TaxCode ? "-" : ""} ${option?.Description
                }`) ||
              ""
            }
            disabled={edit == "false" ? true : false}
            key={(option) => option?.TaxCode}
            filterOptions={filterOptions}
            loading={taxCodeListLoading}
            onChange={(event, newValue) => {
              if (newValue?.TaxCode) {
                setFormState((formState) => ({
                  ...formState,
                  salesTaxCode: newValue?.TaxCode || "",
                  // salesTaxAmount: formState?.calculateTax
                  //   ? newValue?.DefaultValue
                  //   : formState.salesTaxAmount,
                }));

                formState?.calculateTax &&
                  calculateTax(
                    newValue?.TaxCode,
                    "PKR",
                    invoice_Amount,
                    setFormState,
                    setTaxCalculateLoading
                  );
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                // style={{    padding: "10px 10px 12px 10px",
                //   border: "1px solid #0000003b",
                //   borderRadius: "4px",
                //   width: "-webkit-fill-available",}}
                // className="MuiOutlinedInput-input MuiInputBase-input MuiInputBase-inputSizeSmall MuiInputBase-inputAdornedEnd css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input"
                name=""
                required={true}
                disabled={disabled}
                // sx={{
                //   "& fieldset": { border: 'none' },
                // }}
                value={""}
                placeholder="Select a Value"
                // onChange={(event) => {
                //   let objVendor = {
                //     target: { name: "vendor_Code", value: event.target.value },
                //   };
                //   changeHandler(objVendor, index);
                //   getVendorDetail(event.target.value, setVendorCode, setLoading);
                // }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          /> */}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Typography style={{ color: "black" }}>
            <span className={classes.asterisk}>*</span> Input Tax Amount:
          </Typography>
          <TextField
            fullWidth
            size="small"
            name="salesTaxAmount"
            type="number"
            value={formState?.salesTaxAmount || 0}
            required={formState.salesTaxAmount === ""}
            sx={{
              // "& .MuiInputBase-root": { height: 30 },
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
            InputProps={{
              inputProps: { min: 0, step: "0.001" },
              endAdornment: (
                <InputAdornment position="end">
                  {taxCalculateLoading && <CircularProgress size={24} />}
                </InputAdornment>
              ),
            }}
            id="outlined-basic"
            variant="outlined"
            onChange={changeHandler}
            disabled={edit == "false" ? true : false || disabled}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TaxDetail;
